<template>
    <span>{{ timer }}</span>
</template>

<script>
export default {
    name: 'timer',
    props: {
        duration: {
            type: Number,
            required: true,
        },
        clearTimer: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            timeInSeconds: 0,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            interval: null,
        };
    },
    computed: {
        timer() {
            if (this.timeInSeconds === 0) {
                this.$emit('timerFinished');

                return '00';
            }

            let timer = '';

            if (this.seconds !== 0 || (this.seconds === 0 && this.minutes !== 0)) {
                timer = this.pad(this.seconds);
            }

            if (this.minutes !== 0 || (this.minutes === 0 && this.hours !== 0)) {
                timer = this.pad(this.minutes) + ':' + timer;
            }

            if (this.hours !== 0 || (this.hours === 0 && this.days !== 0)) {
                timer = this.pad(this.hours) + ':' + timer;
            }

            if (timer === '00:') {
                timer = '';
            }

            return timer;
        },
    },
    watch: {
        clearTimer() {
            if (this.clearTimer && this.interval) {
                clearInterval(this.interval);
            }
        },
    },
    created() {
        this.timeInSeconds = this.duration;

        /* Calling this method here to convert the duration in seconds passed in the prop to days/hours/minutes/seconds and
           show the formatted timer on entering the page and not showing 0 until this is converted when the timer starts.
        */
        this.convertSecondsToTimerFormat();

        if (this.timeInSeconds) {
            this.startTimer();
        }
    },
    methods: {
        convertSecondsToTimerFormat() {
            this.days = Math.floor(this.timeInSeconds / 24 / 60 / 60);

            const hoursLeft = Math.floor((this.timeInSeconds) - (this.days * 86400));

            this.hours = Math.floor(hoursLeft / 3600);

            const minutesLeft = Math.floor((hoursLeft) - (this.hours * 3600));

            this.minutes = Math.floor(minutesLeft / 60);
            this.seconds = this.timeInSeconds % 60;
        },
        startTimer() {
            this.interval = setInterval(() => {

                this.timeInSeconds--;

                this.convertSecondsToTimerFormat();

                // Will send the remaining seconds to change colour of timer text
                this.$emit('tick', {
                    seconds: this.seconds,
                    remaining: this.timeInSeconds,
                });
            }, 1000);
        },
        pad(value) {
            return (value < 10 ? '0' + value : value);
        },
    },
};
</script>